<template>
  <base-widget>
    <span slot="header">SDCMC DICTIONARY</span>
    <div slot="body" class="dictionary-entries-widget dlcc-dictionary">
      <div v-if="!isAuthorized" class="body">
        <a class="btn btn-light border" href="#" target="_blank">
          Purchase Options
        </a>
      </div>
      <div v-if="isAuthorized" class="header">
        <div class="form-group">
          <div class="input-group">
            <input type="text" v-model="lemma" placeholder="lookup lemma" class="form-control"/>
          </div>
        </div>
      </div>
      <LoaderBall v-if="isAuthorized && $apollo.queries.entries.loading" />
      <div v-else class="body">
        <div v-if="isAuthorized && lemma && lemma.length >= 1" v-for="entry in entries" :key="entry.id">
          <div v-html="entry.data.content"></div>
        </div>
      </div>
      <span class="dictionary-footer">
        Entries from
        <a class="product-link" target="_blank" href="#">Student’s Dictionary of Classical and Medieval Chinese (SCDMC)</a>
      </span>
    </div>
  </base-widget>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'WidgetDLCCDictionary',
  data() {
    return {
      'lemma': '',
      'isAuthorized': true,
    };
  },
  watch: {
    lemma() {
      this.checkAuth();
    },
  },
  mounted() {
    console.log('mounted');
    this.checkAuth();
  },
  methods: {
    async checkAuth() {
      this.isAuthorized = true;
      // TODO
    },
  },
  apollo: {
    entries: {
      query: gql`
        query DictionaryEntries($lemma: String!, $normalizeLemmas: Boolean!) {
          dictionaryEntries(
            lemma: $lemma
            normalizeLemmas: $normalizeLemmas
            dictionary_Urn: "urn:cite2:scholarlyEditions:dictionaries.v1:dlcc"
          ) {
            edges {
              node {
                id
                urn
                headword
                data
              }
            }
          }
        }
      `,
      variables() {
        return {
          lemma: `${this.lemma}`,
          normalizeLemmas: true,
        };
      },
      update(data) {
        return data.dictionaryEntries.edges.map(e => e.node);
      },
      skip() {
        const condition = this.lemma ? this.lemma.length < 1 : true;
        return condition;
      },
    },
  },
};
</script>

<style lang="scss">
  .dlcc-dictionary {
    font-family: 'Brill';
    font-size: 1.1em;

    .dictionary-entry {
      margin-bottom: 2rem;
      border: 1px solid #ccc;
      padding: 1rem;
    }
    span.i {
      font-style: italic;
    }
    span.sup {
      color: red;
    }
    div.Head_character {
      font-size: 2em;
    }
    div.pron {
      margin-top: 1em;
    }
    span.ModSC_pron {
      font-size: 1.2em;
      color: #666;
      font-style: italic;
      padding-right: 0.25em;
    }
    span.MC_pron {
      color: #666;
      font-style: italic;
    }
    span.MC_pron:before {
      content: 'MC ';
      font-style: normal;
      font-weight: bold;
    }
    div.m-meaning {
      margin-top: 0.5em;
      counter-increment: meaning;
    }
    div.m-meaning:before {
      color: #666;
      content: counter(meaning) '. ';
    }
    div.sub-meaning {
      margin-left: 1em;
    }
  }
</style>
